import { Modal, Button as AntButton, Table, TableColumnsType } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SchoolTypeSelect from "../../../common/SchoolTypeSelect";
import Button from "../../../Button";
import { IGetSchools, IGetSchoolsParams, ISchool } from "../../../../models/publishers.model";
import useUtil from "../../../../hooks/useUtil";
import config from "../../../../lib/config";
import useAxios from "../../../../hooks/useAxios";
import useLoader from "../../../../hooks/useLoader";
import { getSchools } from "../../../../api/publishers.api";
import Pagination from "../../../common/Pagination";
import styled from "styled-components";

const Block = styled.div`
  .disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
`;

interface IParams extends Omit<IGetSchoolsParams, 'pageNo'|'perPage'> {};

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  setSchool: (school: ISchool) => void;
};

const SelectSchoolModal: FC<IProps> = ({
  visible,
  setVisible,
  setSchool,
}) => {
  const { t } = useTranslation();
  const { getCommonCodeLabel } = useUtil();
  const { data: res, isLoading, error, execute } = useAxios<IGetSchools>();
  useLoader(isLoading, [error]);

  const [params, setParams] = useState<IParams>({});
  const [pageNo, setPageNo] = useState(1);
  const [schoolGbn, setSchoolGbn] = useState('');
  const [schoolName, setSchoolName] = useState('');

  const columns: TableColumnsType<ISchool> = [
    {
      title: t('student.student.53'),
      dataIndex: 'schoolGbn',
      render: (value) => getCommonCodeLabel('SY0013', value),
    },
    {
      title: t('system.publisher.7'),
      dataIndex: 'schoolKorName',
    },
    {
      title: t('system.publisher.9'),
      dataIndex: 'address',
    },
  ];

  useEffect(() => {
    doGetSchools();
  }, [pageNo]);

  const doGetSchools = (newParams?: IParams) => {
    execute(getSchools({
      pageNo,
      perPage: config.miniPageSize,
      ...(newParams || params),
    }));
  };

  const onSearch = () => {
    const newParams: IParams = {};
    if (schoolGbn) {
      newParams.schoolGbn = schoolGbn;
    }
    if (schoolName) {
      newParams.schoolName = schoolName;
    }
    setParams(newParams);

    if (pageNo === 1) {
      doGetSchools(newParams);
    } else {
      setPageNo(1);
    }
  };

  return (
    <Modal
      title={t('system.publisher.10')}
      visible={visible}
      onCancel={() => setVisible(false)}
      width={600}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="close"
            className='btn-basic gray'
            onClick={() => setVisible(false)}
          >
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <div className="flex">
        <div className="w-150p mr-1">
          <SchoolTypeSelect
            schoolGbn={schoolGbn}
            setSchoolGbn={setSchoolGbn}
          />
        </div>
        <input
          type="text"
          className="form-control mr-2"
          style={{ width: 'calc(100% - 250px)' }}
          placeholder={t('system.school.placeholder')}
          value={schoolName}
          onChange={(e => setSchoolName(e.target.value))}
          onKeyPress={e => { if (e.key === 'Enter') onSearch() }}
        />
        <Button
          className='btn btn-secondary btn-w100p'
          onClick={onSearch}
          text={t('common.button.search')}
        />
      </div>
      <Block>
        <Table
          columns={columns}
          dataSource={res?.data}
          pagination={{
            current: pageNo,
            pageSize: config.miniPageSize,
          }}
          rowClassName={
            record => record.registerYn === 'Y'
              ? 'disabled'
              : 'pointer'
          }
          onRow={record => ({
            onClick: () => {
              if (record.registerYn === 'Y') {
                return;
              }
              setSchool(record);
              setVisible(false);
            },
          })}
        />
      </Block>
      <Pagination
        page={pageNo}
        setPage={setPageNo}
        total={res?.total}
      />
    </Modal>
  );
};

export default SelectSchoolModal;